export default "__VITE_ASSET__Cy57ekBo__"